module.exports = __webpack_public_path__ + "img/icon1.f9ff05c3.svg";